// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__PZ1zJ","sendOtp":"AuthorizeToLogin_sendOtp__3EJeo"};